<template>
  <div class="attendance-clock-stats-page">
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content">
        <div v-if="contextMissionName" class="context-mission">
          当前任务：{{ contextMissionName }}
        </div>

        <el-row class="table-search" type="flex" justify="space-between" align="middle">
          <el-col :xs="24" :md="18">
            <el-form size="medium" :inline="true" :model="searchCondition" class="demo-form-inline">
              <el-form-item label="姓名">
                <el-input
                  v-model.trim="searchCondition.user_name"
                  placeholder="请输入姓名"
                  clearable
                  style="width: 180px;"
                  @keyup.enter.native="searchButton"
                />
              </el-form-item>
              <el-form-item label="打卡状态">
                <el-select
                  v-model="searchCondition.check_status"
                  placeholder="全部"
                  clearable
                  style="width: 120px;"
                >
                  <el-option label="正常" :value="1" />
                  <el-option label="迟到" :value="2" />
                  <el-option label="早退" :value="3" />
                  <el-option label="缺卡" :value="4" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="searchCondition.work_date_start"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="年 / 月 / 日"
                  clearable
                  style="width: 140px;"
                  @change="handleDateRangeChange"
                />
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="searchCondition.work_date_end"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="年 / 月 / 日"
                  clearable
                  style="width: 140px;"
                  @change="handleDateRangeChange"
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchButton">查询</el-button>
                <el-button @click="resetSearch">重置</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :xs="24" :md="6" class="search-right">
            <el-form size="medium" :inline="true">
              <el-form-item label="月份">
                <el-select
                  v-model="monthPreset"
                  placeholder="月份"
                  clearable
                  style="width: 110px;"
                  @change="onMonthPresetChange"
                >
                  <el-option label="本月" value="current" />
                  <el-option label="上月" value="prev" />
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>

        <ApeTable
          ref="apeTable"
          :data="tableList"
          :columns="columns"
          :loading="loadingStatus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <template slot="first-column">
            <el-table-column type="selection" align="center" />
          </template>
          <el-table-column align="center" label="操作" min-width="130" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="openDetailDialog(scope.row, scope.row.action_type === 'view_apply' ? 'apply' : 'view')"
              >
                {{ scope.row.action_text || (scope.row.action_type === "view_apply" ? "查看申请" : "查看") }}
              </el-button>
              <el-button type="text" size="small" @click="openEditDialog(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>

    <el-dialog
      :title="detailDialog.mode === 'apply' ? '查看申请' : '查看'"
      :visible.sync="detailDialog.visible"
      width="640px"
      append-to-body
      destroy-on-close
    >
      <div v-loading="detailDialog.loading" class="record-dialog">
        <div class="record-dialog__title">打卡记录详情</div>
        <div class="record-dialog__section-title">员工信息</div>
        <div class="record-dialog__section record-dialog__section--staff">
          <div class="record-dialog__pair">
            <div class="record-dialog__label">任务名称</div>
            <div class="record-dialog__value">{{ detailMissionName }}</div>
          </div>
          <div class="record-dialog__pair">
            <div class="record-dialog__label">姓名</div>
            <div class="record-dialog__value">{{ detailUserName }}</div>
          </div>
        </div>

        <div class="record-dialog__section-title">打卡详情</div>
        <div class="record-dialog__section">
          <div class="record-dialog__summary">
            <div>
              <div class="record-dialog__label">工作日期</div>
              <div class="record-dialog__value">{{ formatDateCn(detailWorkDate) }}</div>
            </div>
            <div :class="['status-pill', statusClass(detailStatusText)]">
              {{ detailStatusText || "-" }}
            </div>
          </div>

          <div class="record-dialog__time-row">
            <div class="record-dialog__time-card">
              <div class="record-dialog__label">上班打卡</div>
              <div class="record-dialog__value">{{ detailClockInTimeText }}</div>
              <div class="record-dialog__sub">{{ detailClockInLocation }}</div>
            </div>
            <div class="record-dialog__time-card">
              <div class="record-dialog__label">下班打卡</div>
              <div class="record-dialog__value">{{ detailClockOutTimeText }}</div>
              <div class="record-dialog__sub">{{ detailClockOutLocation }}</div>
            </div>
          </div>

          <div class="record-dialog__remark-card">
            <div class="record-dialog__label">备注</div>
            <div class="record-dialog__value">{{ detailRemark }}</div>
          </div>

          <div v-if="detailDialog.mode === 'apply' && detailDialog.applyDetail" class="record-dialog__apply-card">
            <div class="record-dialog__apply-main">
              <div class="record-dialog__label">申请信息</div>
              <div class="record-dialog__apply-grid">
                <div class="record-dialog__apply-item">
                  <span class="record-dialog__apply-key">申请标题</span>
                  <span class="record-dialog__apply-val">{{ applyTitle }}</span>
                </div>
                <div class="record-dialog__apply-item">
                  <span class="record-dialog__apply-key">申请类型</span>
                  <span class="record-dialog__apply-val">{{ applyTypeText }}</span>
                </div>
                <div class="record-dialog__apply-item">
                  <span class="record-dialog__apply-key">审批状态</span>
                  <span class="record-dialog__apply-val">{{ applyStatusText }}</span>
                </div>
                <div class="record-dialog__apply-item">
                  <span class="record-dialog__apply-key">申请时间</span>
                  <span class="record-dialog__apply-val">{{ applyTimeText }}</span>
                </div>
                <div class="record-dialog__apply-item record-dialog__apply-item--full">
                  <span class="record-dialog__apply-key">申请原因</span>
                  <span class="record-dialog__apply-val">{{ applyReasonText }}</span>
                </div>
                <div class="record-dialog__apply-item record-dialog__apply-item--full">
                  <span class="record-dialog__apply-key">审批备注</span>
                  <span class="record-dialog__apply-val">{{ applyRemarkText }}</span>
                </div>
              </div>
            </div>
            <el-button size="small" @click="handleOpenApplyPage">查看申请</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialog.visible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="编辑"
      :visible.sync="editDialog.visible"
      width="680px"
      append-to-body
      destroy-on-close
    >
      <div v-loading="editDialog.loading" class="record-dialog">
        <div class="record-dialog__title">打卡记录详情</div>
        <div class="record-dialog__section-title">员工信息</div>
        <div class="record-dialog__section record-dialog__section--staff">
          <div class="record-dialog__pair">
            <div class="record-dialog__label">任务名称</div>
            <div class="record-dialog__value">{{ editMissionName }}</div>
          </div>
          <div class="record-dialog__pair">
            <div class="record-dialog__label">姓名</div>
            <div class="record-dialog__value">{{ editUserName }}</div>
          </div>
        </div>

        <div class="record-dialog__section-title">打卡详情</div>
        <div class="record-dialog__section">
          <div class="record-dialog__summary">
            <div>
              <div class="record-dialog__label">工作日期</div>
              <div class="record-dialog__value">{{ formatDateCn(editWorkDate) }}</div>
            </div>
            <div :class="['status-pill', statusClass(editStatusText)]">
              {{ editStatusText || "-" }}
            </div>
          </div>

          <div class="record-dialog__time-row">
            <div class="record-dialog__time-card">
              <div class="record-dialog__label">上班打卡</div>
              <el-time-picker
                v-model="editDialog.form.clock_in_time"
                value-format="HH:mm"
                format="HH:mm"
                placeholder="请选择时间"
                style="width: 100%;"
              />
              <div class="record-dialog__sub">{{ editClockInLocation }}</div>
            </div>
            <div class="record-dialog__time-card">
              <div class="record-dialog__label">下班打卡</div>
              <el-time-picker
                v-model="editDialog.form.clock_out_time"
                value-format="HH:mm"
                format="HH:mm"
                placeholder="请选择时间"
                style="width: 100%;"
              />
              <div class="record-dialog__sub">{{ editClockOutLocation }}</div>
            </div>
          </div>

          <div class="record-dialog__remark-card">
            <div class="record-dialog__label">备注</div>
            <div class="record-dialog__value">{{ editRemark }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="editDialog.saving" @click="submitEdit">保存修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";

const PAGE_STATE_KEY = "attendance_clock_stats_page_state";
const RECORD_LIST_REFRESH_FLAG_KEY = "attendance_clock_record_refresh_record_list";
const STATS_LIST_REFRESH_FLAG_KEY = "attendance_clock_record_refresh_stats_list";

function defaultMonthStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

function prevMonthStr() {
  const d = new Date();
  d.setMonth(d.getMonth() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

function formatTime(value) {
  return value && String(value).trim() ? String(value).trim() : "-";
}

export default {
  name: "AttendanceClockStats",
  components: { PageHeaderLayout, ApeTable },
  data() {
    return {
      loadingStatus: false,
      contextMissionId: "",
      contextMissionName: "",
      monthPreset: "current",
      searchCondition: {
        user_name: "",
        check_status: "",
        work_date_start: "",
        work_date_end: "",
        month: defaultMonthStr(),
      },
      columns: [
        { title: "序号", value: "_index", header_align: "center", align: "center", width: 70 },
        { title: "任务名称", value: "mission_name", header_align: "center", align: "center", min_width: 120 },
        { title: "工作日期", value: "work_date", header_align: "center", align: "center", min_width: 110 },
        { title: "姓名", value: "user_name", header_align: "center", align: "center", min_width: 90 },
        { title: "上班打卡", value: "_clockInText", header_align: "center", align: "center", min_width: 90 },
        { title: "下班打卡", value: "_clockOutText", header_align: "center", align: "center", min_width: 90 },
        { title: "打卡地点", value: "location_name", header_align: "center", align: "center", min_width: 120 },
        { title: "打卡方式", value: "check_method_text", header_align: "center", align: "center", min_width: 90 },
        { title: "累计工时", value: "total_work_hours", header_align: "center", align: "center", min_width: 90 },
        { title: "打卡状态", value: "status_text", header_align: "center", align: "center", min_width: 90 },
        { title: "修正状态", value: "_correctStatusText", header_align: "center", align: "center", min_width: 90 },
      ],
      tableList: [],
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        offset: 0,
      },
      detailDialog: {
        visible: false,
        mode: "view",
        loading: false,
        record: null,
        applyDetail: null,
      },
      editDialog: {
        visible: false,
        loading: false,
        saving: false,
        record: null,
        form: {
          clock_in_time: "",
          clock_out_time: "",
        },
      },
    };
  },
  computed: {
    detailRecord() {
      return this.detailDialog.record || {};
    },
    detailMissionName() {
      return this.detailRecord.mission_name || this.contextMissionName || "-";
    },
    detailUserName() {
      return this.detailRecord.user_name || "-";
    },
    detailWorkDate() {
      return this.detailRecord.work_date || "";
    },
    detailStatusText() {
      return this.detailRecord.correct_status_text || this.detailRecord.status_text || "";
    },
    detailClockInTimeText() {
      const time = this.detailRecord.clock_in && this.detailRecord.clock_in.check_time;
      return this.formatDateTimeText(this.detailWorkDate, time);
    },
    detailClockOutTimeText() {
      const time = this.detailRecord.clock_out && this.detailRecord.clock_out.check_time;
      return this.formatDateTimeText(this.detailWorkDate, time);
    },
    detailClockInLocation() {
      return (this.detailRecord.clock_in && this.detailRecord.clock_in.location_name) || this.detailRecord.location_name || "-";
    },
    detailClockOutLocation() {
      return (this.detailRecord.clock_out && this.detailRecord.clock_out.location_name) || this.detailRecord.location_name || "-";
    },
    detailRemark() {
      return this.getRemarkText(this.detailRecord);
    },
    applyDetail() {
      return this.detailDialog.applyDetail || {};
    },
    applyTitle() {
      return this.applyDetail.apply_title || "-";
    },
    applyTypeText() {
      return this.applyDetail.apply_type_text || "-";
    },
    applyStatusText() {
      return this.applyDetail.apply_status_text || "-";
    },
    applyTimeText() {
      return this.applyDetail.apply_time_text || this.applyDetail.submit_time || "-";
    },
    applyReasonText() {
      return this.applyDetail.apply_reason || "-";
    },
    applyRemarkText() {
      return this.applyDetail.apply_remark || "暂无";
    },
    editRecord() {
      return this.editDialog.record || {};
    },
    editMissionName() {
      return this.editRecord.mission_name || this.contextMissionName || "-";
    },
    editUserName() {
      return this.editRecord.user_name || "-";
    },
    editWorkDate() {
      return this.editRecord.work_date || "";
    },
    editStatusText() {
      return this.editRecord.correct_status_text || this.editRecord.status_text || "";
    },
    editClockInLocation() {
      return (this.editRecord.clock_in && this.editRecord.clock_in.location_name) || this.editRecord.location_name || "-";
    },
    editClockOutLocation() {
      return (this.editRecord.clock_out && this.editRecord.clock_out.location_name) || this.editRecord.location_name || "-";
    },
    editRemark() {
      return this.getRemarkText(this.editRecord);
    },
  },
  watch: {
    "$route.query": {
      handler() {
        this.handleRouteChange();
      },
      deep: true,
    },
  },
  mounted() {
    this.handleRouteChange();
    if (!this.contextMissionId) {
      this.$message.warning("缺少任务信息，请从打卡记录列表点击“查看”进入本页");
    }
  },
  beforeDestroy() {
    this.savePageState();
  },
  methods: {
    getDefaultSearchCondition() {
      return {
        user_name: "",
        check_status: "",
        work_date_start: "",
        work_date_end: "",
        month: defaultMonthStr(),
      };
    },
    getRouteStateKey() {
      return `${this.contextMissionId || ""}__${this.contextMissionName || ""}`;
    },
    consumeRefreshFlag() {
      const flag = window.sessionStorage.getItem(STATS_LIST_REFRESH_FLAG_KEY);
      if (flag === "1") {
        window.sessionStorage.removeItem(STATS_LIST_REFRESH_FLAG_KEY);
        return true;
      }
      return false;
    },
    savePageState() {
      let pagingInfo = {
        current_page: 1,
        page_size: this.pagingData.page_size || 10,
      };
      if (this.$refs.apeTable) {
        pagingInfo = this.$refs.apeTable.getPagingInfo();
      }
      window.sessionStorage.setItem(
        PAGE_STATE_KEY,
        JSON.stringify({
          routeKey: this.getRouteStateKey(),
          searchCondition: this.searchCondition,
          monthPreset: this.monthPreset,
          tableList: this.tableList,
          pagingData: this.pagingData,
          pagingInfo,
        }),
      );
    },
    restorePageState() {
      const raw = window.sessionStorage.getItem(PAGE_STATE_KEY);
      if (!raw) return false;
      try {
        const state = JSON.parse(raw);
        if (!state || state.routeKey !== this.getRouteStateKey()) {
          return false;
        }
        this.searchCondition = state.searchCondition || this.getDefaultSearchCondition();
        this.monthPreset = state.monthPreset != null ? state.monthPreset : "current";
        this.tableList = Array.isArray(state.tableList) ? state.tableList : [];
        this.pagingData = state.pagingData || this.pagingData;
        this.$nextTick(() => {
          if (this.$refs.apeTable && state.pagingInfo) {
            this.$refs.apeTable.apePageSize = state.pagingInfo.page_size || 0;
            this.$refs.apeTable.setCurrentChange(state.pagingInfo.current_page || 1);
          }
        });
        return true;
      } catch (e) {
        window.sessionStorage.removeItem(PAGE_STATE_KEY);
        return false;
      }
    },
    handleRouteChange() {
      this.applyRouteContext();
      if (!this.restorePageState()) {
        this.init("search");
        return;
      }
      this.$nextTick(() => {
        if (this.consumeRefreshFlag()) {
          this.init();
        }
      });
    },
    applyRouteContext() {
      const q = this.$route.query || {};
      this.contextMissionId = q.mission_id != null ? String(q.mission_id) : "";
      this.contextMissionName = q.mission_name != null ? String(q.mission_name) : "";
      if (q.month && /^\d{4}-\d{2}$/.test(q.month)) {
        this.searchCondition.month = q.month;
      } else {
        this.searchCondition.month = defaultMonthStr();
      }
      this.syncPresetFromMonth();
    },
    syncPresetFromMonth() {
      const cur = defaultMonthStr();
      const prev = prevMonthStr();
      if (this.searchCondition.month === cur) this.monthPreset = "current";
      else if (this.searchCondition.month === prev) this.monthPreset = "prev";
      else this.monthPreset = "";
    },
    onMonthPresetChange(val) {
      this.searchCondition.work_date_start = "";
      this.searchCondition.work_date_end = "";
      if (val === "current") this.searchCondition.month = defaultMonthStr();
      else if (val === "prev") this.searchCondition.month = prevMonthStr();
      else if (!val) this.searchCondition.month = "";
      this.init("search");
    },
    handleDateRangeChange() {
      if (this.searchCondition.work_date_start || this.searchCondition.work_date_end) {
        this.monthPreset = "";
      }
    },
    formatDateCn(dateStr) {
      if (!dateStr) return "-";
      const parts = String(dateStr).split("-");
      if (parts.length < 3) return dateStr;
      return `${parts[0]}年${parts[1]}月${parts[2]}日`;
    },
    formatDateTimeText(dateStr, timeStr) {
      if (!dateStr) return formatTime(timeStr);
      return `${this.formatDateCn(dateStr)} ${formatTime(timeStr)}`;
    },
    getRemarkText(record = {}) {
      const text =
        record.remark ||
        record.correct_remark ||
        record.origin_remark ||
        record.correct_status_text ||
        record.status_text;
      return text || "正常";
    },
    statusClass(text = "") {
      if (!text) return "status-pill--default";
      if (text.includes("正常")) return "status-pill--success";
      if (text.includes("请假")) return "status-pill--info";
      if (text.includes("迟到") || text.includes("早退")) return "status-pill--warning";
      if (text.includes("缺卡")) return "status-pill--danger";
      return "status-pill--default";
    },
    buildListParams(pagingInfo) {
      const params = {
        mission_id: this.contextMissionId,
        current_page: pagingInfo.current_page,
        page_size: pagingInfo.page_size,
      };
      if (this.searchCondition.user_name) {
        params.user_name = this.searchCondition.user_name.trim();
      }
      if (this.searchCondition.check_status !== "" && this.searchCondition.check_status != null) {
        params.check_status = this.searchCondition.check_status;
      }
      if (this.searchCondition.work_date_start) {
        params.work_date_start = this.searchCondition.work_date_start;
      }
      if (this.searchCondition.work_date_end) {
        params.work_date_end = this.searchCondition.work_date_end;
      }
      if (!params.work_date_start && !params.work_date_end && this.searchCondition.month) {
        params.month = this.searchCondition.month;
      }
      return params;
    },
    async init(type) {
      if (!this.contextMissionId) {
        this.tableList = [];
        this.pagingData.total = 0;
        return;
      }
      if (type && this.mxResetPage) {
        this.mxResetPage();
      }
      this.loadingStatus = true;
      try {
        const pagingInfo = this.$refs.apeTable
          ? this.$refs.apeTable.getPagingInfo(type)
          : { current_page: 1, page_size: 10 };
        if (type === "search") {
          pagingInfo.current_page = 1;
        }
        const res = await this.$api.checkInRecordList(this.buildListParams(pagingInfo));
        const list = Array.isArray(res && res.list) ? res.list : [];
        this.tableList = list.map((item, index) => ({
          ...item,
          _index: (pagingInfo.current_page - 1) * pagingInfo.page_size + index + 1,
          _clockInText: formatTime(item.clock_in_time),
          _clockOutText: formatTime(item.clock_out_time),
          _correctStatusText: item.correct_status_text || "-",
        }));
        const pages = (res && res.pages) || {};
        this.pagingData.total = pages.total || 0;
        this.pagingData.page_size = pagingInfo.page_size;
        this.pagingData.offset =
          pages.offset != null ? pages.offset : (pagingInfo.current_page - 1) * pagingInfo.page_size;
        this.savePageState();
      } catch (e) {
        this.tableList = [];
        const msg =
          (e && e.data && e.data.message) || (e && e.msg) || e.message || "加载失败";
        this.$message.error(msg);
      } finally {
        this.loadingStatus = false;
      }
    },
    searchButton() {
      this.init("search");
    },
    resetSearch() {
      this.searchCondition = this.getDefaultSearchCondition();
      this.monthPreset = "current";
      this.init("search");
    },
    switchPaging() {
      this.init();
    },
    buildRecordPayload(row) {
      return {
        mission_id: row.mission_id,
        shift_id: row.shift_id,
        period_id: row.period_id,
        user_id: row.user_id,
        work_date: row.work_date,
        user_name: row.user_name,
      };
    },
    extractApplyId(row) {
      if (row && row.apply_info && row.apply_info.id) return row.apply_info.id;
      if (row && row.id && row.action_type === "view_apply") return row.id;
      if (row && row.action_url) {
        const match = String(row.action_url).match(/\/([^/]+)$/);
        return match ? match[1] : "";
      }
      return "";
    },
    async openDetailDialog(row, mode = "view") {
      this.detailDialog.visible = true;
      this.detailDialog.mode = mode;
      this.detailDialog.loading = true;
      this.detailDialog.record = null;
      this.detailDialog.applyDetail = null;
      try {
        const record = await this.$api.checkInRecordView(this.buildRecordPayload(row));
        this.detailDialog.record = record || null;
        if (mode === "apply") {
          const applyId = this.extractApplyId(row) || this.extractApplyId(record || {});
          if (applyId) {
            this.detailDialog.applyDetail = await this.$api.checkInApplyView(applyId);
          }
        }
      } catch (e) {
        const msg =
          (e && e.data && e.data.message) || (e && e.msg) || e.message || "获取详情失败";
        this.$message.error(msg);
        this.detailDialog.visible = false;
      } finally {
        this.detailDialog.loading = false;
      }
    },
    async openEditDialog(row) {
      this.editDialog.visible = true;
      this.editDialog.loading = true;
      this.editDialog.record = null;
      this.editDialog.form = {
        clock_in_time: "",
        clock_out_time: "",
      };
      try {
        const record = await this.$api.checkInRecordView(this.buildRecordPayload(row));
        this.editDialog.record = record || null;
        this.editDialog.form.clock_in_time =
          (record && record.clock_in && record.clock_in.check_time) || "";
        this.editDialog.form.clock_out_time =
          (record && record.clock_out && record.clock_out.check_time) || "";
      } catch (e) {
        const msg =
          (e && e.data && e.data.message) || (e && e.msg) || e.message || "获取编辑数据失败";
        this.$message.error(msg);
        this.editDialog.visible = false;
      } finally {
        this.editDialog.loading = false;
      }
    },
    async submitEdit() {
      if (!this.editDialog.record) return;
      if (!this.editDialog.form.clock_in_time || !this.editDialog.form.clock_out_time) {
        this.$message.warning("请填写上下班打卡时间");
        return;
      }
      this.editDialog.saving = true;
      try {
        const payload = {
          mission_id: this.editDialog.record.mission_id,
          shift_id: this.editDialog.record.shift_id,
          period_id: this.editDialog.record.period_id,
          user_id: this.editDialog.record.user_id,
          user_name: this.editDialog.record.user_name,
          work_date: this.editDialog.record.work_date,
          clock_in_time: this.editDialog.form.clock_in_time,
          clock_out_time: this.editDialog.form.clock_out_time,
        };
        await this.$api.checkInRecordUpdate(payload);
        window.sessionStorage.setItem(RECORD_LIST_REFRESH_FLAG_KEY, "1");
        window.sessionStorage.setItem(STATS_LIST_REFRESH_FLAG_KEY, "1");
        this.$message.success("保存成功，状态更新可能稍后生效");
        this.editDialog.visible = false;
        this.init();
      } catch (e) {
        const msg =
          (e && e.data && e.data.message) || (e && e.msg) || e.message || "保存失败";
        this.$message.error(msg);
      } finally {
        this.editDialog.saving = false;
      }
    },
    handleOpenApplyPage() {
      const id =
        (this.detailDialog.applyDetail && this.detailDialog.applyDetail.id) ||
        (this.detailDialog.record &&
          this.detailDialog.record.apply_info &&
          this.detailDialog.record.apply_info.id) ||
        "";
      if (!id) {
        this.$message.warning("缺少申请单 ID");
        return;
      }
      this.detailDialog.visible = false;
      this.$router.push({
        path: "/attendanceApplyAudit",
        query: { id: String(id) },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.context-mission {
  margin-bottom: 12px;
  font-size: 14px;
  color: #606266;
}

.table-search {
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.search-right {
  text-align: right;

  @media (max-width: 992px) {
    text-align: left;
    margin-top: 8px;
  }
}

.record-dialog {
  padding: 0 8px;
}

.record-dialog__title {
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.record-dialog__section-title {
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.record-dialog__section {
  margin-bottom: 16px;
  padding: 14px 16px;
  border: 1px solid #dcdfe6;
  border-radius: 18px;
  background: #fff;
}

.record-dialog__section--staff {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.record-dialog__pair {
  flex: 1;
}

.record-dialog__label {
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.record-dialog__value {
  font-size: 16px;
  color: #303133;
  font-weight: 600;
}

.record-dialog__sub {
  margin-top: 6px;
  font-size: 14px;
  color: #909399;
}

.record-dialog__summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.record-dialog__time-row {
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
}

.record-dialog__time-card {
  flex: 1;
  padding: 12px 14px;
  border: 1px solid #dcdfe6;
  border-radius: 18px;
  background: #fff;
}

.record-dialog__remark-card,
.record-dialog__apply-card {
  padding: 12px 14px;
  border: 1px solid #dcdfe6;
  border-radius: 18px;
  background: #fff;
}

.record-dialog__apply-card {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 12px;
  gap: 16px;
}

.record-dialog__apply-main {
  flex: 1;
}

.record-dialog__apply-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 18px;
}

.record-dialog__apply-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.record-dialog__apply-item--full {
  grid-column: 1 / -1;
}

.record-dialog__apply-key {
  font-size: 13px;
  color: #909399;
}

.record-dialog__apply-val {
  font-size: 14px;
  color: #303133;
  line-height: 1.5;
}

.status-pill {
  min-width: 72px;
  height: 32px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 600;
}

.status-pill--success {
  background: #16c08e;
  color: #ffffff;
}

.status-pill--warning {
  background: #ffad33;
  color: #ffffff;
}

.status-pill--danger {
  background: #ff5252;
  color: #ffffff;
}

.status-pill--info {
  background: #2d8cf0;
  color: #ffffff;
}

.status-pill--default {
  background: #f4f4f5;
  color: #606266;
}
</style>
